import Error from "../utils/Error.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.server.authentication");
log.setLevel(log.levels.WARN);

let Authentication = function (server) {
    this.auto_register = true;

    /**
     * @brief login device id towards server, suppose that device is registered
     * @param {string} login in, device id
     * @param {string} token in, device id
     * @returns
     */
    const mtac_user_login = ({login, token}) => {
        return server
            .post(
                "/user/login",
                {login, token},
                {
                    401: (error) => {
                        throw new Error.build.access({
                            message: `login not authorized by server (${error.message})`,
                            data: {error}
                        });
                    }
                }
            )
            .then((response) => response.json());
    };

    //AGPOC-10179 : Separate Tacteam user management from Tacteam administrator management
    // define login request for admin users so that admin session id (cookie) will be used
    const mtac_user_admin_login = ({login, token}) => {
        return server
            .post(
                "/admin/user/login",
                {login, token},
                {
                    401: (error) => {
                        throw new Error.build.access({
                            message: `login not authorized by server (${error.message})`,
                            data: {error}
                        });
                    }
                }
            )
            .then((response) => response.json());
    };

    const mtac_user_logout = () => {
        log.debug("mtac_user_logout IN");
        var {login} = global.configuration.user;
        if (login === undefined) {
            throw new Error.build.invalid({
                message: "can't logout no register login"
            });
        }
        return server
            .post(
                "/user/logout",
                {login},
                {
                    401: (error) => {
                        throw new Error.build.invalid({
                            message: `logout not authorized by server (${error.message})`,
                            data: {error}
                        });
                    },
                    440: (error) => {
                        throw new Error.build.invalid({
                            message: `user session expired (${error.message})`,
                            data: {error}
                        });
                    }
                }
            )
            .then((response) => response.json());
    };

    const mtac_user_auto_login = () => {
        log.debug("Authentication.mtac_user_auto_login IN");
        var {login, token} = global.configuration.user;
        if (login === undefined || token === undefined) {
            throw new Error.build.invalid({
                message: "can't login no register login or no token defined"
            });
        }
        return mtac_user_login({login, token});
    };

    const mtac_user_admin_auto_login = () => {
        log.debug("mtac_user_admin_auto_login IN");
        var {login, token} = global.configuration.admin;
        if (login === undefined || token === undefined) {
            throw new Error.build.invalid({
                message: "can't login no register login or no token defined"
            });
        }
        return mtac_user_admin_login({login, token});
    };

    this.login = ({login, token}) => {
        log.debug("Authentication.login IN");
        return mtac_user_login({login, token});
    };

    this.auto_login = async () => {
        log.debug("Authentication.auto_login IN");
        try {
            return await mtac_user_auto_login();
        } catch (error) {
            switch (error.status) {
                case Error.status.invalid:
                case Error.status.access:
                    if (!this.auto_register) {
                        throw error;
                    }
                    log.warn("access invalid, re-registering");

                    // To avoid infinite loops when the user is no more known
                    // by the server (ex after cleaning user db)
                    if (global.configuration.user.agnet !== undefined) {
                        // TODO: Simplify this code that is already included in registrar.push() called by registrar.registry_retry() below.
                        global.server.registrar.reset_token();
                    }
                    await global.server.registrar.register_retry({});
                    return await mtac_user_auto_login();
                default:
                    throw error;
            }
        }
    };

    // AGPOC-10179 : Separate Tacteam user management from Tacteam administrator management
    // define auto_login function for admin users so that admin session id (cookie) will be used in following requests
    this.admin_auto_login = async () => {
        log.debug("Authentication:admin_auto_login IN ");
        try {
            return await mtac_user_admin_auto_login();
        } catch (error) {
            switch (error.status) {
                case Error.status.invalid:
                case Error.status.access:
                    if (!this.auto_register) {
                        throw error;
                    }
                    log.warn("access invalid, re-registering");

                    // To avoid infinite loops when the user is no more known
                    // by the server (ex after cleaning user db)
                    if (global.configuration.user.agnet !== undefined) {
                        // TODO: Simplify this code that is already included in registrar.push() called by registrar.registry_retry() below.
                        global.server.registrar.reset_token();
                    }
                    await global.server.registrar.register_retry({});
                    return await mtac_user_admin_auto_login();
                default:
                    throw error;
            }
        }
    };

    this.logout = function () {
        log.debug("logout IN");
        return mtac_user_logout();
    };
};
export default Authentication;
